import { PreviousEmploymentDetailsFormModel_MX } from './formModel';

export const getInitialValues = (): PreviousEmploymentDetailsFormModel_MX => {
  return {
    employmentStatus: undefined,
    occupation: undefined,
    employer: '',
    occupationNotes: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    eirCode: '',
    town: '',
    country: '',
    timeWithEmployerFrom: '',
    timeWithEmployerTo: '',
    netMonthlyIncome: 0,
    netOtherMonthlyIncome: 0,
  };
};
